import {
  CommonDT,
  DateFilter,
  PageParams,
  ResultType,
  Sorter,
} from "../../CommonDT";
import { _delete, _get, _post, _put, _req } from "../../request";

export type FeedbackDataType = CommonDT & {
  content: string;
  fkUserUuid: string;
};

export type FeedbackBatchDataType = {
  feedbacks: FeedbackDataType[];
};

export type FeedbackPageDataType = {
  pageParams: PageParams;
  filter?: FeedbackDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

const get = async (id: string): Promise<ResultType> => {
  return await _get("/usr/feedback/", id);
};

const list = async (data?: FeedbackDataType): Promise<ResultType> => {
  return await _post("/usr/feedback/list", data);
};

const page = async (data?: FeedbackPageDataType): Promise<ResultType> => {
  return await _post("/usr/feedback/page", data);
};

const batchSave = async (data: FeedbackBatchDataType): Promise<ResultType> => {
  return await _post("/usr/feedback/batchSave", data);
};

const batchUpdate = async (
  data: FeedbackBatchDataType
): Promise<ResultType> => {
  return await _put("/usr/feedback/batchUpdate", data);
};

const alterStatus = async (
  feedbackId: string,
  status: number
): Promise<ResultType> => {
  return await _req("/usr/feedback/alterStatus", "PUT", { feedbackId, status });
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete("/usr/feedback/batchRemove", ids);
};

const FeedbackApi = {
  get,
  list,
  page,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
};

export default FeedbackApi;
